import type { TextFieldProps } from '@mui/material';
import { TextField } from '@mui/material';

type TextProps = {
  name: string;
  value: string;
  onChange: (value: string) => void;
  multiline?: boolean;
  error?: string;
  disabled?: boolean;
};

export const Text = (props: TextProps) => {
  const handleChange: TextFieldProps['onChange'] = (e) => {
    props.onChange(e.target.value);
  };

  return (
    <TextField
      variant="standard"
      fullWidth
      name={props.name}
      value={props.value}
      onChange={handleChange}
      minRows={3}
      multiline={props.multiline}
      error={Boolean(props.error)}
      helperText={props.error}
      FormHelperTextProps={{ sx: { marginTop: 0 } }}
      disabled={props.disabled}
    />
  );
};
